import { render, staticRenderFns } from "./goodsLabel.vue?vue&type=template&id=1da5aae2&"
import script from "./goodsLabel.vue?vue&type=script&lang=js&"
export * from "./goodsLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports